import type { UserInfo } from "@/types/common";
import { isPlatformRole, type PlatformRole } from "@/lib/platformRoles";
import { isTenantStaffRole } from "@/lib/staffPermissions";

export const STAFF_UI_MODES = ["tenant", "platform"] as const;
export type StaffUiMode = (typeof STAFF_UI_MODES)[number];

export function getPlatformRole(
  userInfo: UserInfo | null
): PlatformRole | null {
  if (isPlatformRole(userInfo?.platformRole)) return userInfo.platformRole;
  // ローリング移行中の旧APIレスポンスにも対応する。
  return isPlatformRole(userInfo?.role) ? userInfo.role : null;
}

export const hasTenantAccess = (userInfo: UserInfo | null): boolean =>
  isTenantStaffRole(userInfo?.role);

export const hasPlatformAccess = (userInfo: UserInfo | null): boolean =>
  getPlatformRole(userInfo) !== null;

export const getDefaultStaffMode = (userInfo: UserInfo | null): StaffUiMode =>
  hasTenantAccess(userInfo)
    ? "tenant"
    : hasPlatformAccess(userInfo)
      ? "platform"
      : "tenant";

export const isStaffUiMode = (value: unknown): value is StaffUiMode =>
  STAFF_UI_MODES.some((mode) => mode === value);
